import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { NavLink } from 'react-router-dom';

import { createTheme, ThemeProvider } from '@mui/material/styles';
import DeviceHubIcon from '@mui/icons-material/DeviceHub';
import BackIcon from '@mui/icons-material/ArrowBack';
import DeveloperModeIcon from '@mui/icons-material/DeveloperMode';
import PersonIcon from '@mui/icons-material/Person';
import BugReportIcon from '@mui/icons-material/BugReport';
import { Breadcrumbs, Button, Stack, Typography } from '@mui/material';
import Grid from '@mui/material/Grid2';

import { PageSection } from '../subs/PageSection';
import { ButtonLink } from '../subs/ButtonLink';

import { BreadCrumbProps } from "../subs/PageAlternate";

// global theming ruins the back button, disable it here
const backTheme = createTheme({
    components: {
        MuiButton: {
            styleOverrides: {
                root: {
                },
            },
        }
    }
});
const breadcrumbs: BreadCrumbProps[] = [
    { to: "/Administration", text: "Administration" },
];

export const DBFunctionPage = () => {
    const navigate = useNavigate();

    const backButtonHandler = () => navigate(-1);

    return <>
        <Stack direction="row" spacing={200}>
            <ThemeProvider theme={backTheme}>
                <Button startIcon={<BackIcon />} size="small" onClick={backButtonHandler}>back</Button>
            </ThemeProvider>
            {breadcrumbs && <Breadcrumbs separator="|">
                {breadcrumbs.map((crumb, index) => (
                    <NavLink key={index} to={crumb.to}>{crumb.text}</NavLink>
                ))}
            </Breadcrumbs>}
        </Stack>
        <PageSection>
            {[<>
                <Typography variant={'h5'}>
                    {"Administration Functions"}
                </Typography>
            </>]}
        </PageSection>
        <Grid container spacing={2}>
            <Grid size={2}>
                <ButtonLink fullWidth to={`/AllUsersAdmin`} startIcon={<PersonIcon/>}>User Admin</ButtonLink>
            </Grid>
            <Grid size={1} />
            <Grid size={2}>
                <ButtonLink fullWidth to={`/ArchitectureAdmin`} startIcon={<DeviceHubIcon/>}>Testing Pair Combinations</ButtonLink>
            </Grid>
            <Grid size={1} />
            {/*  <Grid size={2}>
                <ButtonLink fullWidth to={`/LogFileAdminPage`} startIcon={<BugReportIcon />}>Logs</ButtonLink>
            </Grid>
            <Grid size={1} />*/}
            <Grid size={2}>
                <Button
                    fullWidth
                    variant="outlined"
                    component="a"
                    href={`/api/dev/downloadalllog`}
                    target="_blank"
                    rel="noopener noreferrer"
                    startIcon={<BugReportIcon />}
                    className={"buttonLink"}
                >
                    Download Logs
                </Button>
            </Grid>
            <Grid size={1}/>
            <Grid size={2}>
                <ButtonLink fullWidth to={`/DBViewDevDebug`} startIcon={<DeveloperModeIcon/>}>Dev Data</ButtonLink>
            </Grid>
        </Grid>
    </>
}